import { Instagram, Facebook } from "lucide-react";
import { SOCIAL_LINKS } from "@/lib/socialLinks";

type TickerItem = {
  text: string;
  href?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
};

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" width={12} height={12} fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.18 8.18 0 004.77 1.52V6.84a4.84 4.84 0 01-1-.15z" />
  </svg>
);

const items: TickerItem[] = [
  {
    text: "PLYM HAIR & EXTENSIONS",
    onClick: () => window.dispatchEvent(new CustomEvent("open-live-chat")),
  },
  {
    text: "24 HR CUSTOMER SERVICE",
    onClick: () => window.dispatchEvent(new CustomEvent("open-live-chat")),
  },
  {
    text: "FREE UK DELIVERY ON ORDERS OVER £50",
  },
  {
    text: "PREMIUM WIGS & EXTENSIONS",
    href: "/shop",
  },
  {
    text: "CALL US: 01752 651631",
    href: "tel:+441752651631",
  },
  {
    text: "INSTAGRAM",
    href: SOCIAL_LINKS.instagram.href,
    icon: <Instagram size={12} />,
  },
  {
    text: "FACEBOOK",
    href: SOCIAL_LINKS.facebook.href,
    icon: <Facebook size={12} />,
  },
  {
    text: "TIKTOK",
    href: SOCIAL_LINKS.tiktok.href,
    icon: <TikTokIcon />,
  },
];

const TickerContent = () => (
  <>
    {items.map((item, i) => (
      <span key={i} className="inline-flex items-center gap-6 px-6">
        {item.href ? (
          <a
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : undefined}
            rel={item.href.startsWith("http") ? "noopener" : undefined}
            className="inline-flex items-center gap-1.5 text-xs font-body tracking-widest uppercase hover:text-primary transition-colors"
          >
            {item.icon}
            {item.text}
          </a>
        ) : item.onClick ? (
          <button
            onClick={item.onClick}
            className="inline-flex items-center gap-1.5 text-xs font-body tracking-widest uppercase hover:text-primary transition-colors cursor-pointer"
          >
            {item.icon}
            {item.text}
          </button>
        ) : (
          <span className="inline-flex items-center gap-1.5 text-xs font-body tracking-widest uppercase">
            {item.icon}
            {item.text}
          </span>
        )}
        <span className="text-primary">———</span>
      </span>
    ))}
  </>
);

const Ticker = () => (
  <div className="bg-ticker text-ticker-foreground overflow-hidden whitespace-nowrap py-2.5">
    <div className="ticker-scroll inline-flex">
      <TickerContent />
      <TickerContent />
    </div>
  </div>
);

export default Ticker;
